export const LOCALE_COOKIE_NAME = 'locale';

// Get the preferred locale from cookie (works on both server and client)
export const getPreferredLocale = (req) => {
  // Server side - from request headers
  if (req && req.headers && req.headers.cookie) {
    const cookies = req.headers.cookie.split(';');
    const localeCookie = cookies.find(cookie => 
      cookie.trim().startsWith(`${LOCALE_COOKIE_NAME}=`)
    );
    return localeCookie ? localeCookie.split('=')[1] : null;
  }
  
  // Client side - from document.cookie
  if (typeof window !== 'undefined') {
    const cookies = document.cookie.split(';');
    const localeCookie = cookies.find(cookie => 
      cookie.trim().startsWith(`${LOCALE_COOKIE_NAME}=`)
    );
    return localeCookie ? localeCookie.split('=')[1] : null;
  }
  
  return null;
};

// Set the preferred locale in cookie
export const setPreferredLocale = (locale) => {
  if (typeof window === 'undefined') return;
  
  const expirationDate = new Date();
  expirationDate.setFullYear(expirationDate.getFullYear() + 1); // 1 year expiration
  
  // Set domain based on environment
  const hostname = window.location.hostname;
  let domainPart = '';
  
  if (hostname.includes('dropbox.com')) {
    // For any dropbox.com subdomain (including learn.dropbox.com)
    domainPart = '; domain=.dropbox.com';
  } else if (hostname.includes('localhost')) {
    // For localhost testing
    domainPart = '; domain=localhost';
  }
  // For other domains, no domain specified (uses current domain)
  
  document.cookie = `${LOCALE_COOKIE_NAME}=${locale}; expires=${expirationDate.toUTCString()}; path=/${domainPart}`;
  
  const domainDisplay = hostname.includes('dropbox.com') ? '.dropbox.com' : 
                       hostname.includes('localhost') ? 'localhost' : 'current';
  console.log(`Locale cookie set: ${locale} (domain: ${domainDisplay})`);
};

// Debug function to see all cookies
export const debugAllCookies = () => {
  if (typeof window === 'undefined') return;
  
  console.log('=== ALL COOKIES ===');
  const cookies = document.cookie.split(';');
  cookies.forEach((cookie, index) => {
    const [name, value] = cookie.trim().split('=');
    console.log(`${index + 1}. ${name} = ${value}`);
  });
  console.log('==================');
};

// Check which domain is set for the locale cookie
export const checkCookieDomain = () => {
  if (typeof window === 'undefined') return 'server-side';
  
  const hostname = window.location.hostname;
  console.log(`Current hostname: ${hostname}`);
  
  // Check what domain would be set based on current logic
  let expectedDomain;
  if (hostname.includes('dropbox.com')) {
    expectedDomain = '.dropbox.com';
  } else if (hostname.includes('localhost')) {
    expectedDomain = 'localhost';
  } else {
    expectedDomain = 'current domain';
  }
  
  console.log(`Expected domain for cookie: ${expectedDomain}`);
  
  // Get all cookies and check for locale cookie
  const cookies = document.cookie.split(';');
  const localeCookie = cookies.find(cookie => 
    cookie.trim().startsWith(`${LOCALE_COOKIE_NAME}=`)
  );
  
  if (localeCookie) {
    console.log(`Found locale cookie: ${localeCookie.trim()}`);
    console.log(`Cookie value: ${localeCookie.split('=')[1]}`);
  } else {
    console.log('No locale cookie found');
  }
  
  return {
    hostname,
    expectedDomain,
    cookieExists: !!localeCookie,
    cookieValue: localeCookie ? localeCookie.split('=')[1] : null
  };
};
